export enum EEventType {
    Intervention = 1,
    Pause = 2,
    Formation = 3,
}
